<template>
<main>
  <PmHeader></PmHeader>
  <div class="container">
    <br>
    <article class="panel is-info">
      <p class="panel-heading">
        Parámetros
      </p>
      <a class="panel-block is-active">
        <span class="panel-icon">
        </span>
        <router-link class="nav-item" to="certificado">Certificado</router-link>
      </a>
      <a class="panel-block">
        <span class="panel-icon">
        </span>
        <router-link class="nav-item" to="servidor_correo">Servidor de Correo</router-link>
      </a>
    </article>
  </div>
</main>
</template>
<script>
import PmHeader from '../components/layout/Header.vue'

export default {
  components: {
    PmHeader
  },

  data: () => ({
    tracks: [],
    mensaje: '',
    showNotification: false,
    showNotificationCertificado: false,
    mensajeCertificado: '',
    numeroPendientes: 0,
    usuario: {}
  }),

  mounted() {
    if (localStorage.getItem('token')) {
      this.usuario = JSON.parse(localStorage.getItem('usuario'))
    } else {
      this.$router.push('/')
    }    
  }
}
</script>
  